<script>
  import { createEventDispatcher } from "svelte";

  import Field from "./field.svelte";
  import Buttons from './buttons.svelte';
  import Path from "./path.svelte";

  export let openapi;
  export let schema;
  export let layout;
  export let value;
  export let errors;
  export let dirty;
  export let canBeSubmitted;
  export let loading;
  export let editable;
  export let currentPath;
  export let texts = undefined;
  export let extras = undefined;

  const dispatch = createEventDispatcher();
</script>

{#if editable && !layout.contents.length}
  <Path { layout } current={ currentPath } on:message={ ({ detail }) => { dispatch('message', detail) } } />
{/if}
<svelte:element this={ layout.tag || 'div' } id={ layout.id } class={ layout.class }>
  {#each layout.contents as content}
    {@const newPath = [ ...currentPath, content ]}
    {#if content.type === 'field'}
      <Field
        id={ content.id }
        { openapi } schema={ schema.properties[content.id] }
        required={ schema.required && schema.required.includes(content.id) } errors={ errors && errors[content.id] }
        { editable } currentPath={ newPath } { texts } { extras }
        bind:value={ value[content.id] } bind:canBeSubmitted={ canBeSubmitted } bind:loading={ loading }
        bind:dirty={ dirty }
        on:message={ ({ detail }) => { dispatch('message', detail) } }
      >

        <svelte:fragment slot="array-widgets" let:addArrayWidget={ addArrayWidget } let:removeArrayWidget={ removeArrayWidget }>
          <slot name="array-widgets" { addArrayWidget } { removeArrayWidget }></slot>
        </svelte:fragment>
        <svelte:fragment slot="wallet-yours" let:value={ value } let:setValue={ setValue }>
          <slot name="wallet-yours" { value } { setValue } />
        </svelte:fragment>

      </Field>
    {:else if content.type === 'buttons'}
      <Buttons
        layout={ content } { editable } currentPath={ newPath } class={ content.class } { texts } { extras }
        bind:canBeSubmitted={ canBeSubmitted } bind:loading={ loading }
        on:cancel={ () => { dispatch('cancel') } } on:message={ ({ detail }) => { dispatch('message', detail) } }
      />
    {:else}
      <svelte:self
        { openapi } { schema }
        layout={ content } { errors }
        { editable } currentPath={ newPath } { texts } { extras }
        bind:value={ value } bind:canBeSubmitted={ canBeSubmitted } bind:loading={ loading }
        bind:dirty={ dirty }
        on:cancel={ () => { dispatch('cancel') } } on:message={ ({ detail }) => { dispatch('message', detail) } }
      >

        <svelte:fragment slot="array-widgets" let:addArrayWidget={ addArrayWidget } let:removeArrayWidget={ removeArrayWidget }>
          <slot name="array-widgets" { addArrayWidget } { removeArrayWidget }></slot>
        </svelte:fragment>
        <svelte:fragment slot="wallet-yours" let:value={ value } let:setValue>
          <slot name="wallet-yours" { value } { setValue } />
        </svelte:fragment>

      </svelte:self>
    {/if}
  {/each}
</svelte:element>